import { useAuth } from "../../../hooks/customers/AuthProvider";
import CustomCurrencyFormat from "../../utils/CurrencyFormat";

function PriceBox(props) {
  let { price, special_price, _id,code } = props.item;
  const auth = useAuth();
  const customer = auth.customer;
  const customerSpecialPrices = customer?.customerSpecialPrices;
  price = typeof price == "object" ? price["$numberDecimal"] : price;
  special_price =
    typeof special_price == "object"
      ? special_price["$numberDecimal"]
      : special_price;
  let findalPrice = price;
  if (special_price > 0) {
    findalPrice = special_price;
  }
  if (customerSpecialPrices && customerSpecialPrices[code]) {
    findalPrice = customerSpecialPrices[code].price;
  }
  return (
    <>
      <CustomCurrencyFormat amount={findalPrice} />
    </>
  );
}

export default PriceBox;
